import { render, staticRenderFns } from "./org-staff-modal.vue?vue&type=template&id=1a52532a&scoped=true&"
import script from "./org-staff-modal.vue?vue&type=script&lang=js&"
export * from "./org-staff-modal.vue?vue&type=script&lang=js&"
import style0 from "./org-staff-modal.vue?vue&type=style&index=0&id=1a52532a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a52532a",
  null
  
)

export default component.exports